import { Box, Button, Paper, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MailOutline } from "@mui/icons-material";
import tintoaLogoWhite from "../img/logo_tintoa_white.png";
import tintoaLogoBlack from "../img/logo_tintoa_black.png";

/**
 * Notice page for expired or unknown invitation links.
 * Deliberately minimal: no login, no form, no resend.
 */
export const InviteExpiredScreen = () => {
    const theme = useTheme();
    const isDarkTheme = theme.palette.mode === "dark";
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "background.default",
                p: 2
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 3, sm: 5 },
                    maxWidth: 480,
                    width: "100%",
                    textAlign: "center",
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 2
                }}
            >
                <img
                    src={isDarkTheme ? tintoaLogoWhite : tintoaLogoBlack}
                    alt="tintoa-logo"
                    style={{ height: 32, marginBottom: 24 }}
                />
                <MailOutline
                    sx={{ fontSize: 64, color: "text.secondary", mb: 2 }}
                />
                <Typography variant="h5" gutterBottom>
                    Diese Einladung ist nicht mehr gültig
                </Typography>
                <Typography color="text.secondary" sx={{ mb: 4 }}>
                    Der Einladungslink ist abgelaufen oder wurde zurückgezogen.
                    Bitte wende dich an die Person, die dich eingeladen hat, um
                    eine neue Einladung zu erhalten.
                </Typography>
                <Button
                    variant="outlined"
                    onClick={() => navigate("/app/login")}
                >
                    Zur Anmeldung
                </Button>
            </Paper>
        </Box>
    );
};
